<template>
     <span>
          
          <b-form
               @submit="onSubmit"
               @reset="onReset">


          <b-form-row>
               <!-- <b-col cols="12" md="6"> -->
               <b-col>
                    <b-card>
                         <h4 class="detail-section-title">
                              <b-form-group
                                   id="notification-notificationMethod_Pushover-group"
                                   :state="formValidation.notificationMethod"
                                   :invalid-feedback="formValidation.notificationMethodMessage">
                                   
                                   <b-form-radio 
                                        v-model="localUserData.notificationMethod" 
                                        name="some-radios" 
                                        value="pushover">
                                        
                                        Pushover
                                   
                                   </b-form-radio>

                              </b-form-group>

                         </h4>

                         <b-card-text class="section-description mb-3">
                              Send me reminders using
                              <b-link href="https://www.pushover.net/" target="_blank">Pushover</b-link>.
                              If you are unfamiliar with this service, please review this
                              <b-link
                                   href="https://support.pushover.net/i7-what-is-pushover-and-how-do-i-use-it"
                                   target="_blank"
                              >
                                   article
                              </b-link>
                              from their knowledge base.
                         </b-card-text>

                         <b-collapse 
                              id="pushover-info" 
                              :visible="localUserData.notificationMethod == 'pushover' || 1 == 1">
                              <b-form-group
                                   id="notification-pushoverApiKey-group"
                                   :state="formValidation.pushoverApiKey"
                                   valid-feedback="Looks good!"
                                   :invalid-feedback="formValidation.pushoverApiKeyMessage"
                              >
                                   <label class="detail-label" for="pushoverApiKey">USER KEY</label>
                                   <b-form-input
                                        id="pushoverApiKey"
                                        v-model.trim="localUserData.pushoverApiKey"
                                        :state="formValidation.pushoverApiKey"
                                        size="sm"
                                   />

                                   <b-form-text class="section-description mt-2">
                                        Your user key is obtained from
                                        <b-link href="https://www.pushover.net/" target="_blank">Pushover</b-link>
                                        and is displayed after logging into your account.
                                   </b-form-text>
                              </b-form-group>

                              <b-form-group
                                   id="notification-pushoverObserveQuietHours-group"
                                   class="mt-3"
                                   :state="formValidation.pushoverObserveQuietHours"
                                   valid-feedback="Looks good!"
                                   invalid-feedback="This information is required."
                              >
                                   <label class="detail-label" for="pushoverObserveQuietHours">OBSERVE QUIET HOURS</label>
                                   <b-form-select 
                                        id="pushoverObserveQuietHours"
                                        v-model="localUserData.pushoverObserveQuietHours" 
                                        :state="formValidation.pushoverObserveQuietHours"
                                        :options="yesornoOnly"
                                        value-field="item"
                                        text-field="name"
                                        size="sm"/>

                                   <b-form-text class="section-description mt-2">
                                        By selecting yes, Principal Task will never send a high-priority notification 
                                        thus allowing it to observe the "Quiet Hours" specified in your Pushover
                                        <b-link href="https://pushover.net/settings" target="_blank">Settings</b-link>.
                                   </b-form-text>
                              </b-form-group>

                              
                         </b-collapse>
                    </b-card>
               </b-col>

               <!-- <b-col cols="12" md="6">
                    <b-card>
                         <h4>
                              

                              <b-form-group
                                   id="notification-notificationMethod_SMS-group"
                                   :state="formValidation.notificationMethod"
                                   :invalid-feedback="formValidation.notificationMethodMessage">
                                   
                                   <b-form-radio 
                                        v-model="localUserData.notificationMethod" 
                                        name="some-radios" 
                                        value="sms">
                                        
                                        SMS
                                   
                                   </b-form-radio>

                              </b-form-group>

                         </h4>

                         <b-card-text>Send me reminders using SMS (text) message.  (Your carrier's message and data rates may apply.)</b-card-text>

                         <b-collapse 
                              id="sms-info" 
                              :visible="localUserData.notificationMethod == 'sms' || 1 == 1">
                              <b-form-group
                                   id="notification-mobileNumber-group"
                                   label="Mobile Number"
                                   label-for="mobileNumber"
                                   description
                                   :state="formValidation.mobileNumber"
                                   valid-feedback="Looks good!"
                                   invalid-feedback="This information is required."
                              >
                                   <b-form-input
                                        id="mobileNumber"
                                        v.model.trim="localUserData.mobileNumber"
                                        :state="formValidation.mobileNumber"
                                   />

                                   <b-form-text>
                                        Enter your US-based mobile number.  This information will only be used for sending
                                        messages related to Principal Task.
                                   </b-form-text>
                              </b-form-group>

                              <b-form-group
                                   id="notification-smsCostAcknowledgement-group"
                                   label="I opt to receive SMS (text) messages"
                                   label-for="mobileNumber"
                                   description
                                   :state="formValidation.mobileNumber"
                                   valid-feedback="Looks good!"
                                   invalid-feedback="This information is required."
                              >
                                   <b-form-select 
                                        id="smsCostAcknowledgement"
                                        v-model="localUserData.smsCostAcknowledgement" 
                                        :state="formValidation.smsCostAcknowledgement"
                                        :options="yesornoOnly"
                                        value-field="item"
                                        text-field="name"
                                        size="sm"/>

                                   <b-form-text>
                                        By selecting yes, you authorize Schwenk Technology Group, the operator of Principal Task, to send you service related alerts via SMS (text) message.  Furthermore,
                                        you accept that your mobile provider may apply their own message and data charges.
                                   </b-form-text>
                              </b-form-group>

                              
                         </b-collapse>

                    </b-card>

                    
               </b-col> -->
          </b-form-row>

          <b-row class="mt-4">
               <b-col cols="12" style="text-align:right;">
                    <b-button
                         ref="resetButton"
                         class="mr-2"
                         variant="warning"
                         type="reset"
                    >
                         Cancel
                    </b-button>

                    <b-button
                         ref="submitButton"
                         class="mr-2"
                         variant="success"
                         type="submit"
                    >
                         Save
                    </b-button>
               </b-col>
          </b-row>
          </b-form>
     </span>
</template>

<script>

import genericOps from '../mixins/genericOps.js'
import LocalPushoverService from '@/services/LocalPushoverService.js'

export default {
     name: 'ReminderConfiguration',
     components: {
          
     },
     mixins: [
          genericOps
     ],
     props: {
          userData: {
               type: Object,
               default: () => {},
          },
     },
     data() {
          return {
               formValidation: {
                    mobileNumber: null,
                    notificationMethod: null,
                    pushoverApiKey: null,
                    pushoverApiKeyMessage: null,
                    smsCostAcknowledgement: null
               },
          }
     },
     computed: {
          localUserData: {
               get: function() {
                    return this.userData
               },
               set: function(newValue) {
                    this.userData = newValue
               },
          },
     },
     methods: {
          buildDefaultUserDataObject() {
               return {}
          },
          onReset(evt) {
               evt.preventDefault()
          },
          async onSubmit(evt) {

               evt.preventDefault()

               this.$refs.resetButton.disabled = true
               this.$refs.submitButton.disabled = true

               this.formValidation = {}
               this.formValidation.valid = true

               if(typeof this.localUserData.notificationMethod != 'undefined' && this.localUserData.notificationMethod !== null) {

                    // Validate data for Pushover notifications
                    if(this.localUserData.notificationMethod == 'pushover') {

                         if(typeof this.localUserData.pushoverObserveQuietHours == 'undefined' || this.localUserData.pushoverObserveQuietHours === null) {

                              this.formValidation.valid = false
                              this.formValidation.pushoverObserveQuietHours = false

                         }

                         if(typeof this.localUserData.pushoverApiKey == 'undefined' || this.localUserData.pushoverApiKey === null) {
                              
                              this.formValidation.valid = false
                              this.formValidation.pushoverApiKey = false
                              this.formValidation.pushoverApiKeyMessage = 'This information is required.' 
                                   + this.localUserData.pushoverApiKey
                                   + this.userData.pushoverApiKey
                         
                         } else {

                              // Validate user's key
                              await LocalPushoverService.validate(this.localUserData.pushoverApiKey, this.$store.getters.getUserToken)
                              .then(async (response) => {

                                   //console.log('LocalPushoverService.validate response = ' + JSON.stringify(response))

                                   // Send a test notification

                                   let message = 'Pushover notifications are enabled.  '
                                   + 'You can configure these notifications from your Principal Task profile.'

                                   await LocalPushoverService.messageSimple(message, this.localUserData.pushoverApiKey, this.$store.getters.getUserToken)
                                   .then((response) => {

                                        console.log('LocalPushoverService.message response = ' + JSON.stringify(response))

                                   }).catch((error) => {

                                        console.log('LocalPushoverService.message error = ' + JSON.stringify(error))
                                        
                                        this.formValidation.valid = false

                                        // 20200719 -- ZWS -- Using $set because these appear to be non-reactive, even though
                                        // their earlier use is reactive.
                                        this.$set(this.formValidation, 'pushoverApiKey', false)
                                        this.$set(this.formValidation, 'pushoverApiKeyMessage', 'Unable to use key for confirmation notification (' 
                                             + error.response.data.message + ').  Please try again later.')
                                        
                                   })

                              }).catch((error) => {

                                   console.log('error = ' + JSON.stringify(error))
                                   console.log(JSON.stringify(error.response.data))
                                   
                                   this.formValidation.valid = false

                                   // 20200719 -- ZWS -- Using $set because these appear to be non-reactive, even though
                                   // their earlier use is reactive.
                                   this.$set(this.formValidation, 'pushoverApiKey', false)
                                   this.$set(this.formValidation, 'pushoverApiKeyMessage', 'Unable to use key.  Key is ' + error.response.data.message + '.')

                              })
                         
                         }

                    // Validate data for SMS notifications
                    } else if(this.localUserData.notificationMethod == 'sms') {

                    } else {

                         this.formValidation.valid = false
                         this.formValidation.notificationMethod = false
                         this.formValidation.notificationMethodMessage = 'Unsupported notification method (' + this.localUserData.notificationMethod + ').'

                    }

               } else {

                    this.formValidation.valid = false
                    this.formValidation.notificationMethod = false
                    this.formValidation.notificationMethodMessage = 'You must select a notification method.'

               }

               if(this.formValidation.valid) {

                    this.$emit('submitted:ReminderConfigurationForm', this.localUserData)

                    this.$refs.resetButton.disabled = false
                    this.$refs.submitButton.disabled = false

               } else {
                    
                    this.$refs.resetButton.disabled = false
                    this.$refs.submitButton.disabled = false

               }

          },
          
     }
}
</script>

<style scoped>
.detail-section-title {
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: var(--spacing-md);
  padding-bottom: var(--spacing-sm);
  border-bottom: 2px solid var(--accent-color);
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.detail-label {
  font-size: 0.625rem;
  font-weight: 500;
  color: var(--text-secondary);
  margin-bottom: var(--spacing-xs);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  display: block;
}

.section-description {
  font-size: 0.875rem;
  color: var(--text-secondary);
  line-height: 1.5;
}

.task-card-actions-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5rem;
  padding-top: 1rem;
  border-top: 1px solid #e9ecef;
  margin-top: 1rem;
}
</style>
